<template>
    <div>
        <div class="title-div">
            <!-- 최소배달금액 O -->
            <div class="title-right" v-if="minPromo > 0">
                <span style="font-weight: 500;font-size:16px; line-height: 1.5">{{ `최소주문금액 ${numberWithCommas(minPromo)}` }}</span><br>
                <!-- <span style="font-weight: 500;font-size:16px;" v-if="minPromo <= totalValue"> / 배달가능</span>
                <span style="font-weight: 500;font-size:16px;" v-else> / 배달불가</span> -->
                <span class="lack-value" v-if="lackPromo > 0">
                    {{numberWithCommas(lackPromo)}}
                </span>
                <span style="font-weight: 500;" v-if="lackPromo > 0"> 추가시 주문가능</span>
                <span class="lack-value" v-else>주문가능</span><br>
            </div>
            <!-- 최소배달금액 X.-->
            <div class="title-right" v-else>
              <br>
              <span class="lack-value">주문가능</span><br>
            </div>
            <!-- 배달조건충족.-->
        </div>
        <div class="progress-main" v-if="this.minPromo !== 0">
            <div class="progress">
                <div class="progress-bar" :class="classes" :style="`${customStyle} width: ${newPercentage}%;`" aria-valuemax="100">
                </div>
                <img src="@/assets/icon/tery.svg" style="margin-left: -10px; height: 30px; object-fit:conatin;z-index:999;" alt="">
            </div>
            <div class="progress-right">
                <img src="@/assets/icon/icon_bike.svg" style="width: 30px;object-fit:contain;margin-bottom: 10px;" alt="">
            </div>
        </div>
        <div class="progress-main" v-else>
            <div class="progress">
                <div class="progress-bar" :class="classes" :style="`${customStyle} width: 100%;`" aria-valuemax="100">
                </div>
                <img src="@/assets/icon/tery.svg" style="margin-left: -10px; height: 30px; object-fit:conatin;z-index:999;" alt="">
            </div>
            <div class="progress-right">
                <img src="@/assets/icon/icon_bike.svg" style="width: 30px;object-fit:contain;margin-bottom: 10px;" alt="">
            </div>
        </div>
        <div class="title-right">
          <span style="font-weight: 500;" v-if="deliveryCost > 0">{{ `배달료: ${numberWithCommas(deliveryCost)}` }}</span>
          <span style="font-weight: 500;" v-else>무료배달</span><br>
        </div>
    </div>
</template>
<script>
export default {
  name: 'ProgressBar',
  props: {
    title: {type: String},
    percentage: {type: Number, default: 100},
    delay: {type: Number, default: 0},
    bg: {type: String, default: 'primary'},
    customBgColor: {type: String, default: null},
    animation: {type: Boolean, default: false},
    striped: {type: Boolean, default: false},
    totalValue: {type: Number, default: 0}, // 결제금액
    minPromo: {type: Number, default: 0}, // 최소 배달 금액
    lackPromo: {type: Number, default: 0}, // 모자란 금액
    // newPercentage: {type: Number, default: 0}, // 프로그레스바 퍼센트
    deliveryCost: {type: Number, default: 0} // 배달료
    // overCost: {type: Number, default: 0} // 두번째 ~ 배달 설정금액
  },
  data () {
    return {
      classes: null,
      customStyle: ''
    }
  },
  computed: {
    newPercentage: {
      get () {
        return Math.ceil(this.percentage)
      },
      set (newPercentage) {
        return newPercentage
      }
    }
  },
  created () {
    this.classes = 'bg-' + this.bg
    if (this.customBgColor != null) { this.customStyle = ` background-color:${this.customBgColor}!important;` }
    if (this.animation) { this.classes = this.classes + ' progress-bar-animated' }
    if (this.striped) { this.classes = this.classes + ' progress-bar-striped' }
  },
  mounted () {
    setTimeout(() => {
      this.newPercentage = Math.ceil(this.percentage)
    }, this.delay)
  },
  methods: {
    numberWithCommas (x) {
      if (!x) {
        return '0원'
      } else if (x === 0 || x === '0') {
        return ''
      } else {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '원'
      }
    }
  }
}
</script>

<style scoped>
    .title-div {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .title-left {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 15px;
    }
    .title-right {
        flex: 2;
        /* display: flex; */
        align-items: center;
        /* justify-content: flex-start; */
        text-align:right;
        /* flex-direction: column; */
        font-size: 14px;
    }
    .lack-value {
        color: #EA4E83;
        /* font-size: 12px; */
        font-weight: 500;
    }
    /* .lack-span {
    } */
    .progress-main {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
        box-sizing: border-box;
    }
    .progress {
        flex: 10;
        display:-webkit-box;
        display:-ms-flexbox;
        display:flex;
        height:5px;
        overflow:visible;
        font-size:.75rem;
        background-color: red;
        border-radius:.25rem;
        margin:5px 0 10px;
        align-items: center;
        background: rgba(0, 0, 0, 0.1);
        text-align:right;
        /* border: 1px solid red; */
        box-sizing: border-box;
    }
    .progress-right {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .progress-bar{
        display:-webkit-box;
        display:-ms-flexbox;
        display:flex;
        height: 5px;
        -webkit-box-orient:vertical;
        -webkit-box-direction:normal;
        -ms-flex-direction:column;
        flex-direction:column;
        -webkit-box-pack:center;
        -ms-flex-pack:center;
        justify-content:center;
        color:#fff;
        text-align:center;
        background-color:#007bff;
        transition:width .6s ease;
        border-radius: 4px;
        box-sizing: border-box;
    }
    .progress-bar-striped{
        background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
        background-size:1rem 1rem;
    }
    .progress-bar-animated{
        -webkit-animation:progress-bar-stripes 1s linear infinite;
        animation:progress-bar-stripes 1s linear infinite;
    }
    @-webkit-keyframes progress-bar-stripes {
        from{background-position:1rem 0}
        to{background-position:0 0}
    }
    @keyframes progress-bar-stripes {
        from{background-position:1rem 0}
        to{background-position:0 0}
    }
    .bg-success{background-color:#28a745!important}
    .bg-secondary{background-color:#6c757d!important}
    .bg-info{background-color:#17a2b8!important}
    .bg-danger{background-color:#dc3545!important}
    .bg-warning{background-color:#ffc107!important}
    .bg-turquoise{background-color:#1abc9c!important}
    .bg-amethyst{background-color:#9b59b6!important}
    .bg-midnightblue{background-color:#2c3e50!important}
    .bg-electronblue{background-color:#0984e3!important}
    .bg-shymoment{background-color:#a29bfe!important}
    .bg-pinkglamour{background-color:#ff7675!important}
    .bg-brightyarrow{background-color:#fdcb6e!important}
    .bg-americanriver{background-color:#636e72!important}
    .bg-picopink{background-color:#fd79a8!important}
    .bg-pink{background-color:pink!important}
    .bg-exodusfruit{background-color:#686de0!important}
    .bg-pureapple{background-color:#6ab04c!important}
    .bg-terypink{background-color:#EA4E83!important}
</style>



// WEBPACK FOOTER //
// src/components/shareComponent/VueJsProgress.vue